import { Box, Button, Card, CardContent, Container, Divider, Fade, FormControl, Grid, InputAdornment, InputLabel, Modal, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import { createMantenimiento } from '../../domain/api/MantenimientoApi';
import { useLocation, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch } from 'react-redux';
import { ROL_USER, USER_ID } from '../../../app/api-client/constants';
import { format } from 'date-fns';
import { loadMantenimientos } from '../../domain/api/DocumentosApi';

const useStyles = makeStyles((theme) => ({
  root: {
    display: '1 0 auto',
    borderRadius: '18px',
    background: 'primary',

  },
  details: {
    display: 'flex',
    flexDirection: 'column',

  },
  content: {
    flex: 'auto',
    background: '#ffffff',
    display: 'flex',

  },
  cover: {
    width: 151,
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  playIcon: {
    height: 38,
    width: 38,
  },
  contentContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  button: {
    marginLeft: 'auto',
    height: 50,
    width: 100,
    alignItems: 'center',
    justifyContent: 'center',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '600px',
    margin: 'auto'

  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: '10px'
  },
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  input: {
    display: 'none',
  },
  root: {
    display: '1 0 auto',
    borderRadius: '18px',
    background: process.env.REACT_APP_PRIMARY_THEMA,

  },
  details: {
    display: 'flex',
    flexDirection: 'column',

  },
  content: {
    flex: 'auto',
    background: '#ffffff',
    display: 'flex',

  },
  cover: {
    width: 151,
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  playIcon: {
    height: 38,
    width: 38,
  },
  hidden: {
    display: 'none',
  }


}));

export default function DatosMantenimiento({ getDataTable }) {
  let { id } = useParams();
  let id_user = localStorage.getItem(USER_ID)
  const location = useLocation();
  const nameBascula = location.state?.nameBascula;
  const ubicacion = location.state?.ultimaConexion;
  const key = location.state?.key;

  const dispatch = useDispatch();
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [newRegister, setNewRegister] = useState([]);
  const [actividad, setActividad] = useState("");
  const [detalle, setDetalle] = useState("");
  const [evidencia, setEvidencia] = useState("");
  const [encargado, setEncargado] = useState("");
  const [responsable, setResponsable] = useState("");
  const [documento_responsable, setDocumento_responsable] = useState("");
  const [cargo_responsable, setCargo_responsable] = useState("");
  const [celular_responsable, setCelular_responsable] = useState("");
  const [file, setFile] = useState();
  let rol = localStorage.getItem(ROL_USER)
  const handleOpen = () => {
    setOpen(true);

  };
  const handleClose = () => {
    setOpen(false);
  };
  const userForm = () => {
    setActividad("");
    setDetalle("");
    setEvidencia("");
    setEncargado("");
    setResponsable("");
    setDocumento_responsable("");
    setCargo_responsable("");
    setCelular_responsable("");
  };

  const create = async () => {
    let Request =
    {
      evbi: id,
      usuario: id_user,
      detalle: detalle,
      evidencia: evidencia,
      encargado: encargado,
      actividad: actividad,
      responsable: responsable,
      documento_responsable: documento_responsable,
      cargo_responsable: cargo_responsable,
      celular_responsable: celular_responsable
    }


    const responseAsigned = await createMantenimiento(dispatch, Request)
    try {
      setNewRegister(responseAsigned.codigoRespuesta);
      handleClose();
      userForm();
      getDataTable();
    } catch (err) {
      console.log("Ocurrio un error", err)
    }

  }

  const onFileUploadFacture = async (event, type) => {
    type = type === null || type === undefined ? "" : type;
    const file = event.target.files[0];
    const currentDate = format(new Date(), 'yyyy-MM-dd-HH-mm-ss');
    if (file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/jpg" || file.type === "application/pdf" || file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
      const formData = new FormData();
      const lastDot = file.name === undefined ? file.name = "" : file.name.lastIndexOf(".");
      const ext = file.name.substring(lastDot + 1);
      const nombreBascula = nameBascula.replace(/\s+/g, "_");
      const nombre = `mantenimiento-${detalle.replace(/\s+/g, "_")}_${currentDate}.${ext}`;
      setEvidencia(nombre);
      formData.append("file", file, nombre);
      if (file.size < 10485760 && id !== "") {
        const File = await loadMantenimientos(dispatch, nombreBascula, formData);
        try {
          setFile(File.codigoRespuesta);
        } catch (err) {
          console.log("Ocurrio un error", err);
        }
      }
    }
  };
  const opciones = [
    { value: '', label: 'Tipo de actividad' },
    { value: 'Mantenimiento', label: 'Mantenimiento' },
    { value: 'Acompañamiento', label: 'Acompañamiento' },
    { value: 'Actualización', label: 'Actualización' },
    { value: 'Capacitación', label: 'Capacitación' },
    { value: 'Limpieza', label: 'Limpieza' },
  ];
  const cancelar = async () => {
    handleClose()
    setActividad("");
    setDetalle("");
    setEvidencia("");
    setEncargado("");
    setResponsable("");
    setDocumento_responsable("");
    setCargo_responsable("");
    setCelular_responsable("");
  };
  const theme = useTheme(); // Obtén el tema

  const primaryColor = theme.palette.primary.main;
  const inputStyles = {
    border: `1px solid ${primaryColor}`, // Usa el color primario del tema para el borde
    color: 'black',
    fontSize: '18px'
  };
  return (
    <>
      <Card className={classes.root}>
        <div className={classes.details}>
          <Container className={classes.contentContainer} style={{ marginLeft: '15px', backgroundColor: '#ffffff' }}>
            <CardContent className={classes.content}>
              <Grid>
                <Typography component="h6" variant="h6">
                  Evbi
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">{nameBascula ? nameBascula : "--"}</Typography>
              </Grid>
              <Divider style={{ marginLeft: '1%', background: '#D9D9D9' }} orientation="vertical" flexItem />
              <Grid style={{ marginLeft: '15px' }}>
                <Typography component="h6" variant="h6">
                  Ubicación
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">{ubicacion}</Typography>
              </Grid>

              <Divider style={{ marginLeft: '1%', background: '#D9D9D9' }} orientation="vertical" flexItem />

              <Grid style={{ marginLeft: '15px' }}>
                <Typography component="h6" variant="h6">
                  Key
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">{key ? key : "--"}</Typography>
              </Grid>
              <Button
                className={`${classes.button} ${rol !== 'ROLE_ADMIN' && rol !== 'ROLE_SUPPORT' && rol !== 'ROLE_CLIENT' ? classes.hidden : ''}`}
                variant="contained"
                color="primary"
                type="button"
                onClick={handleOpen}
                style={{ borderRadius: '10px' }}
              >
                Cargar
              </Button>


            </CardContent>
          </Container>

        </div>
      </Card>

      <div>

        <Modal
          className={classes.modal}
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div className={classes.paper}>
              <Container>

                <Grid item xs={12} md={12} sm={12} style={{ marginTop: '2rem' }} >
                  <FormControl fullWidth variant="outlined" color='primary'>

                    <input
                      placeholder='Actividades Realizadas *'
                      type='actividades'
                      labelWidth={120} // o 150 u otro valor
                      id="actividades"
                      style={inputStyles}
                      multiline
                      value={detalle}
                      onChange={e => {
                        setDetalle(e.target.value);
                      }}
                      rows={4}

                      name='actividades'
                      startAdornment={<InputAdornment position="start">-</InputAdornment>}
                      label="Actividades Realizadas"
                      autoComplete='off'
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={12} sm={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '2rem' }}>
                  <FormControl fullWidth variant="outlined">

                    <input
                      placeholder='Evidencia(URL)*'
                      id="evidencia"
                      type="evidencia"
                      name='evidencia'
                      disabled
                      style={inputStyles}
                      value={evidencia}
                      startAdornment={<InputAdornment position="start"></InputAdornment>}
                      label="Evidencia"
                    />
                  </FormControl>
                  <div className={classes.root} style={{ marginLeft: '10px' }}>
                    <input
                      accept="image/jpeg, image/png, image/jpg, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      className={classes.input}
                      id="contained-button-file"
                      multiple
                      type="file"
                      onChange={((e) => { onFileUploadFacture(e,) })}
                    />
                    <label htmlFor="contained-button-file">
                      <Button variant="contained" color="primary" component="span"
                        style={{ borderRadius: '10px' }}
                      >
                        Cargar
                      </Button>
                    </label>
                    <input accept="image/*" className={classes.input} id="icon-button-file" type="file" />
                  </div>
                </Grid>

                <Grid container spacing={2}>
                  <Grid item xs={12} md={6} sm={6} style={{ marginTop: '2rem' }}>
                    <FormControl fullWidth variant="outlined">

                      <input
                        placeholder='Encargado'
                        labelWidth={120}
                        id="encargado"
                        multiline
                        style={inputStyles}
                        value={encargado}
                        onChange={e => {
                          setEncargado(e.target.value);
                        }}
                        type="text"
                        name='encargado'
                        startAdornment={<InputAdornment position="start">-</InputAdornment>}
                        label="Encargado"
                        autoComplete='off'
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={6} sm={6} style={{ marginTop: '2rem' }}>
                    <FormControl fullWidth variant="outlined">

                      <select
                        placeholder='Tipo de actividad'
                        labelId="demo-simple-select-outlined-label"
                        id="tipoactividad"
                        name="tipoactividad"
                        value={actividad}
                        style={inputStyles}
                        onChange={e => {
                          setActividad(e.target.value)
                        }}
                        label="Tipo de actividad"
                        startAdornment={<InputAdornment position="start">-</InputAdornment>}
                      >
                        {opciones.map((opcion) => (
                          <option key={opcion.value} value={opcion.value}>
                            {opcion.label}
                          </option>
                        ))}
                      </select>
                    </FormControl>
                  </Grid>
                </Grid>

                <Box component="fieldset" border={1} borderRadius={8} borderColor="grey.500" p={2} style={{ marginTop: '2rem' }} >
                  <InputLabel>Recibe:</InputLabel>
                  <Grid container spacing={2} style={{ marginTop: '10px' }}>
                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth variant="outlined">

                        <input
                          placeholder='Responsable *'
                          id="responsable"
                          style={inputStyles}
                          type="text"
                          name='responsable'
                          value={responsable}
                          onChange={e => {
                            setResponsable(e.target.value);
                          }}
                          startAdornment={<InputAdornment position="start">-</InputAdornment>}
                          label="Responsable"
                          autoComplete='off'
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth variant="outlined">

                        <input
                          placeholder='Documento *'
                          id="documento"
                          style={inputStyles}
                          type="text"
                          name='documento'
                          value={documento_responsable.replace(/[^0-9]/g, '')}
                          onChange={e => {
                            if (e.target.value.length < 15) {
                              setDocumento_responsable(e.target.value);
                            }

                          }}
                          startAdornment={<InputAdornment position="start">-</InputAdornment>}
                          label="Documento"
                          autoComplete='off'
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth variant="outlined">

                        <input
                          placeholder='Cargo'
                          id="campo"
                          type="text"
                          style={inputStyles}
                          name='campo'
                          value={cargo_responsable}
                          onChange={e => {
                            setCargo_responsable(e.target.value);
                          }}
                          startAdornment={<InputAdornment position="start">-</InputAdornment>}
                          label="Campo"
                          autoComplete='off'
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth variant="outlined">

                        <input
                          placeholder='Celular *'
                          id="celular"
                          type="text"
                          name='celular'
                          style={inputStyles}
                          value={celular_responsable.replace(/[^0-9]/g, '')}
                          onChange={e => {
                            if (e.target.value.length < 11) {
                              setCelular_responsable(e.target.value);
                            }
                          }}
                          startAdornment={<InputAdornment position="start">-</InputAdornment>}
                          label="Celular"
                          autoComplete='off'
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Box>


                <Grid item xs={12} style={{ textAlign: "center", marginTop: '2rem', display: 'flex', justifyContent: 'center' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    type="button"
                    onClick={create}
                    disabled={
                      !detalle ||
                      !actividad ||
                      !responsable ||
                      !documento_responsable ||
                      !celular_responsable}
                    style={{ borderRadius: '10px' }}


                  >
                    Guardar
                  </Button>
                  <Button
                    style={{ marginLeft: '10px', borderRadius: '10px' }}
                    variant="contained"
                    color='primary'
                    type="button"
                    onClick={cancelar}
                  >
                    Cancelar
                  </Button>
                </Grid>

              </Container>
            </div>
          </Fade>
        </Modal>
      </div>


    </>
  );


}